// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c2HGiQckyTfz_Xkaq4Gf {
  border-bottom: #e6e4e4 1px solid;
  border-left: #e6e4e4 1px solid;
}
.QHVXlFsB_0im88anJFfs {
  display: flex;
  border-bottom: #e6e4e4 1px solid;
}
.QHVXlFsB_0im88anJFfs:last-child {
  border-bottom: none;
}
.QHVXlFsB_0im88anJFfs:nth-of-type(even) {
  background-color: #f5f5f5;
}
.iKLffb2PoYfWsYzCduVi {
  width: 155px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: #e6e4e4 1px solid;
  padding-left: 4px;
}
.iKLffb2PoYfWsYzCduVi:last-child {
  border-right: none;
}
.iKLffb2PoYfWsYzCduVi.cKCE8lq1SpkpXOh0Koha {
  width: 200px;
}
.iKLffb2PoYfWsYzCduVi .LAnoBubAE6o5TthtZmoq {
  margin-left: 16px;
}
.iKLffb2PoYfWsYzCduVi .jFrw7fMWRs2R5VQXiUKQ {
  margin-left: 32px;
}
.iBEielmF4NI7LY4CFB4q {
  display: flex;
}
.OJX21L1MjaMmsD2DpbmW {
  color: #999;
  font-size: 0.8rem;
  padding: 0.15rem 0.2rem 0rem 0.2rem;
  user-select: none;
  cursor: pointer;
}
.X4FIRdLzu8ZkAIyxv4nB {
  font-size: 0.6rem;
  padding-left: 1rem;
  user-select: none;
}
.XT82t0A9Lf2WpJ0gWVSA {
  display: flex;
  box-sizing: border-box;
  border: #e6e4e4 1px solid;
  border-right: none;
}
.A7kFYLzGBO5BVarlUBSw {
  padding-left: 4px;
  display: flex;
  align-items: center;
  height: 100%;
  width: 155px;
  border-right: #e6e4e4 1px solid;
}
.A7kFYLzGBO5BVarlUBSw:last-child {
  border-right: none;
}
.A7kFYLzGBO5BVarlUBSw.cKCE8lq1SpkpXOh0Koha {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/Gantt/TaskList/index.module.less"],"names":[],"mappings":"AAGA;EACE,gCAAA;EACA,8BAAA;AAFF;AAKA;EACE,aAAA;EACA,gCAAA;AAHF;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,yBAAA;AAFJ;AAMA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;AAJF;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAVA;EAkBI,iBAAA;AALJ;AAbA;EAqBI,iBAAA;AALJ;AASA;EACE,aAAA;AAPF;AAUA;EACE,WAAA;EACA,iBAAA;EACA,mCAAA;EACA,iBAAA;EACA,eAAA;AARF;AAWA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;AATF;AAYA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAVF;AAaA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;AAXF;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,YAAA;AAXJ","sourcesContent":["@itemWidth: 155px;\n@nameWidth: 200px;\n\n.taskListWrapper {\n  border-bottom: #e6e4e4 1px solid;\n  border-left: #e6e4e4 1px solid;\n}\n\n.taskListTableRow {\n  display: flex;\n  border-bottom: #e6e4e4 1px solid;\n  &:last-child {\n    border-bottom: none;\n  }\n  &:nth-of-type(even) {\n    background-color: #f5f5f5;\n  }\n}\n\n.taskListCell {\n  width: @itemWidth;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-right: #e6e4e4 1px solid;\n  padding-left: 4px;\n  &:last-child {\n    border-right: none;\n  }\n\n  &.name {\n    width: @nameWidth;\n  }\n\n  .nameLevel-2 {\n    margin-left: 16px;\n  }\n  .nameLevel-3 {\n    margin-left: 32px;\n  }\n}\n\n.taskListNameWrapper {\n  display: flex;\n}\n\n.taskListExpander {\n  color: #999;\n  font-size: 0.8rem;\n  padding: 0.15rem 0.2rem 0rem 0.2rem;\n  user-select: none;\n  cursor: pointer;\n}\n\n.taskListEmptyExpander {\n  font-size: 0.6rem;\n  padding-left: 1rem;\n  user-select: none;\n}\n\n.header {\n  display: flex;\n  box-sizing: border-box;\n  border: #e6e4e4 1px solid;\n  border-right: none;\n}\n\n.headerItem {\n  padding-left: 4px;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: @itemWidth;\n  border-right: #e6e4e4 1px solid;\n  &:last-child {\n    border-right: none;\n  }\n\n  &.name {\n    width: @nameWidth;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taskListWrapper": `c2HGiQckyTfz_Xkaq4Gf`,
	"taskListTableRow": `QHVXlFsB_0im88anJFfs`,
	"taskListCell": `iKLffb2PoYfWsYzCduVi`,
	"name": `cKCE8lq1SpkpXOh0Koha`,
	"nameLevel-2": `LAnoBubAE6o5TthtZmoq`,
	"nameLevel-3": `jFrw7fMWRs2R5VQXiUKQ`,
	"taskListNameWrapper": `iBEielmF4NI7LY4CFB4q`,
	"taskListExpander": `OJX21L1MjaMmsD2DpbmW`,
	"taskListEmptyExpander": `X4FIRdLzu8ZkAIyxv4nB`,
	"header": `XT82t0A9Lf2WpJ0gWVSA`,
	"headerItem": `A7kFYLzGBO5BVarlUBSw`
};
export default ___CSS_LOADER_EXPORT___;
